var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Informe CS",
        visible: _vm.showing,
        width: "45rem",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showing = $event
        },
      },
    },
    [
      _vm.completed
        ? _c("Reports-SuccessMessageWithHistoricalLink", {
            attrs: { reportName: "CS" },
          })
        : _c("Forms-Form", {
            attrs: { options: _vm.formOptions },
            on: { submit: _vm.onSubmit },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }